
export const getAuthHeader = (username, password, content_type = 'application/json') => {
    const token = btoa(`${username}:${password}`);
    return {
        'Authorization': `Basic ${token}`,
        'Content-Type': content_type
    };
};

// 'application/json'